import { render, staticRenderFns } from "./StaffGroupPageTable.vue?vue&type=template&id=3b50bb7b&scoped=true&"
import script from "./StaffGroupPageTable.vue?vue&type=script&lang=js&"
export * from "./StaffGroupPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b50bb7b",
  null
  
)

export default component.exports